/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Protocol_Delivery_Hint_LinkInputs */

const cs_tasks_protocol_delivery_hint_link = /** @type {(inputs: Tasks_Protocol_Delivery_Hint_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bez pozvánek — odkazy k podpisu zkopírujte nebo otevřete sami (tablet / QR / chat).`)
};

const en_tasks_protocol_delivery_hint_link = /** @type {(inputs: Tasks_Protocol_Delivery_Hint_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No invite emails — copy or open the signing URLs yourself (tablet / QR / chat).`)
};

/**
* | output |
* | --- |
* | "No invite emails — copy or open the signing URLs yourself (tablet / QR / chat)." |
*
* @param {Tasks_Protocol_Delivery_Hint_LinkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_protocol_delivery_hint_link = /** @type {((inputs?: Tasks_Protocol_Delivery_Hint_LinkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Protocol_Delivery_Hint_LinkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_protocol_delivery_hint_link(inputs)
	return cs_tasks_protocol_delivery_hint_link(inputs)
});